/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	isUserLoggedIn: () => {
		return localStorage.getItem("userInfo") && localStorage.getItem("accessToken") ? true : false;
	},
	getUserRole: () => {
    let userInfo = localStorage.getItem("userInfo");
    userInfo = JSON.parse(userInfo);
    if (userInfo) {
      return userInfo.userRole;
    }
    return '';
	}
};
